import {
  GET_REVENUE_LIST,
  GET_REVENUE_LIST_SUCCESS,
  GET_REVENUE_LIST_FAILED,
  EXPORT_REVENUE_LIST,
  EXPORT_REVENUE_LIST_SUCCESS,
  EXPORT_REVENUE_LIST_FAILED,
} from './actionTypes';

export const actionGetRevenueList = (payload) => ({
  payload,
  type: GET_REVENUE_LIST,
});

export const actionGetRevenueListSuccess = (payload) => ({
  payload,
  type: GET_REVENUE_LIST_SUCCESS,
});

export const actionGetRevenueListFailed = () => ({
  type: GET_REVENUE_LIST_FAILED,
});

export const actionExportRevenueList = (payload) => ({
  payload,
  type: EXPORT_REVENUE_LIST,
});

export const actionExportRevenueListSuccess = () => ({
  type: EXPORT_REVENUE_LIST_SUCCESS,
});

export const actionExportRevenueListFailed = () => ({
  type: EXPORT_REVENUE_LIST_FAILED,
});
